export const SOURCES = [
  {
    key: `www`,
    url: `https://admin.startupitalia.eu/graphql`,
  },
  {
    key: `startupitalia`,
    url: `https://admin.startupitalia.eu/graphql`,
  },
  {
    key: `startupitalia.eu`,
    url: `https://admin.startupitalia.eu/graphql`,
  },
  {
    key: `admin.startupitalia.eu`,
    url: `https://admin.startupitalia.eu/graphql`,
  },
  {
    key: `impact`,
    url: `https://impact-admin.startupitalia.eu/graphql`,
  },
  {
    key: `impact.startupitalia.eu`,
    url: `https://impact-admin.startupitalia.eu/graphql`,
  },
  {
    key: `impact-admin.startupitalia.eu`,
    url: `https://impact-admin.startupitalia.eu/graphql`,
  },
  {
    key: `cybersecurity`,
    url: `https://cybersecurity-admin.startupitalia.eu/graphql`,
  },
  {
    key: `cybersecurity.startupitalia.eu`,
    url: `https://cybersecurity-admin.startupitalia.eu/graphql`,
  },
  {
    key: `cybersecurity-admin.startupitalia.eu`,
    url: `https://cybersecurity-admin.startupitalia.eu/graphql`,
  },
  {
    key: `ischool`,
    url: `https://ischool-admin.startupitalia.eu/graphql`,
  },
  {
    key: `ischool.startupitalia.eu`,
    url: `https://ischool-admin.startupitalia.eu/graphql`,
  },
  {
    key: `ischool-admin.startupitalia.eu`,
    url: `https://ischool-admin.startupitalia.eu/graphql`,
  },
  {
    key: `openinnovation`,
    url: `https://openinnovation-admin.startupitalia.eu/graphql`,
  },
  {
    key: `openinnovation.startupitalia.eu`,
    url: `https://openinnovation-admin.startupitalia.eu/graphql`,
  },
  {
    key: `openinnovation-admin.startupitalia.eu`,
    url: `https://openinnovation-admin.startupitalia.eu/graphql`,
  },
  {
    key: `smartworking`,
    url: `https://smartworking-admin.startupitalia.eu/graphql`,
  },
  {
    key: `smartworking.startupitalia.eu`,
    url: `https://smartworking-admin.startupitalia.eu/graphql`,
  },
  {
    key: `smartworking-admin.startupitalia.eu`,
    url: `https://smartworking-admin.startupitalia.eu/graphql`,
  },
  {
    key: `smartmoney`,
    url: `https://smartmoney-admin.startupitalia.eu/graphql`,
  },
  {
    key: `smartmoney.startupitalia.eu`,
    url: `https://smartmoney-admin.startupitalia.eu/graphql`,
  },
  {
    key: `smartmoney-admin.startupitalia.eu`,
    url: `https://smartmoney-admin.startupitalia.eu/graphql`,
  },
  {
    key: `sportup`,
    url: `https://sportup-admin.startupitalia.eu/graphql`,
  },
  {
    key: `sportup.startupitalia.eu`,
    url: `https://sportup-admin.startupitalia.eu/graphql`,
  },
  {
    key: `sportup-admin.startupitalia.eu`,
    url: `https://sportup-admin.startupitalia.eu/graphql`,
  },
  {
    key: `thefoodmakers`,
    url: `https://thefoodmakers-admin.startupitalia.eu/graphql`,
  },
  {
    key: `thefoodmakers.startupitalia.eu`,
    url: `https://thefoodmakers-admin.startupitalia.eu/graphql`,
  },
  {
    key: `thefoodmakers-admin.startupitalia.eu`,
    url: `https://thefoodmakers-admin.startupitalia.eu/graphql`,
  },
  {
    key: `thenexttech`,
    url: `https://thenexttech-admin.startupitalia.eu/graphql`,
  },
  {
    key: `thenexttech.startupitalia.eu`,
    url: `https://thenexttech-admin.startupitalia.eu/graphql`,
  },
  {
    key: `thenexttech-admin.startupitalia.eu`,
    url: `https://thenexttech-admin.startupitalia.eu/graphql`,
  },
  {
    key: `valoreresponsabile`,
    url: `https://valoreresponsabile-admin.startupitalia.eu/graphql`,
  },
  {
    key: `valoreresponsabile.startupitalia.eu`,
    url: `https://valoreresponsabile-admin.startupitalia.eu/graphql`,
  },
  {
    key: `valoreresponsabile-admin.startupitalia.eu`,
    url: `https://valoreresponsabile-admin.startupitalia.eu/graphql`,
  },
  {
    key: `life`,
    url: `https://life-admin.startupitalia.eu/graphql`,
  },
  {
    key: `life.startupitalia.eu`,
    url: `https://life-admin.startupitalia.eu/graphql`,
  },
  {
    key: `life-admin.startupitalia.eu`,
    url: `https://life-admin.startupitalia.eu/graphql`,
  },
  {
    key: `staging`,
    url: `https://startupitalia.c.wpstage.net/graphql`,
  },
  {
    key: `staging.startupitalia.eu`,
    url: `https://startupitalia.c.wpstage.net/graphql`,
  },
  {
    key: `startupitalia.c.wpstage.net`,
    url: `https://startupitalia.c.wpstage.net/graphql`,
  },
];